import SectionHeader from './SectionHeader'

const joinClassNames = (...parts) => parts.filter(Boolean).join(' ')

export function TemplatePage({ children, className = '', ...restProps }) {
  return (
    <section className={joinClassNames('gg-page-template', className)} {...restProps}>
      {children}
    </section>
  )
}

export function TemplateHeaderBlock({
  eyebrow = '',
  title = '',
  description = '',
  actions = null,
  children = null,
  className = '',
  ...restProps
}) {
  return (
    <section className={joinClassNames('gg-module-panel gg-module-panel--wide gg-page-template__header', className)} {...restProps}>
      <SectionHeader eyebrow={eyebrow} title={title} description={description} actions={actions} className="gg-page-template__section-header" />
      {children}
    </section>
  )
}

export function TemplateSummaryRow({ children, className = '', ...restProps }) {
  return <div className={joinClassNames('gg-page-template__summary', className)} {...restProps}>{children}</div>
}

export function TemplateSectionCard({
  label = '',
  title = '',
  subtitle = '',
  actions = null,
  children,
  className = '',
  ...restProps
}) {
  return (
    <section className={joinClassNames('gg-module-panel gg-page-template__section', className)} {...restProps}>
      {label ? <p className="gg-module-panel__label">{label}</p> : null}
      {title || subtitle || actions ? (
        <div className="gg-tool-header">
          <div>
            {title ? <h3 className="gg-tool-title">{title}</h3> : null}
            {subtitle ? <p className="gg-tool-subtitle">{subtitle}</p> : null}
          </div>
          {actions ? <div className="gg-form-actions">{actions}</div> : null}
        </div>
      ) : null}
      {children}
    </section>
  )
}

export function TemplateFormShell({ children, className = '', ...restProps }) {
  return <div className={joinClassNames('gg-page-template__form-shell', className)} {...restProps}>{children}</div>
}

export function TemplateTableShell({ children, className = '', ...restProps }) {
  return <div className={joinClassNames('gg-page-template__table-shell', className)} {...restProps}>{children}</div>
}
